<nav class="sh-tab-navigation">
    @for (tab of tabs; track tab; let i = $index) {
        <a [routerLink]="$any(tab).route" [attr.data-index]="i" class="sh-tab-navigation__item" (click)="onSelect(i)" [class.-sh-is-active]="i == activeTab">
            {{ tab.label }}
        </a>
    }
</nav>
